// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"368":"217a4a49","867":"56831013","875":"5575b9c0","928":"0b8795fa","985":"aa322424"}[chunkId] + ".js";
};